import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { CHECKOUT_URL } from '../data/constants';
const INCLUDED = ['6 professional modules', '5 professional bonuses', 'Engine & starting diagnostics', 'Fuel & intake troubleshooting', 'Electrical & charging diagnostics', 'ECU & sensor troubleshooting', 'Complete fault-finding workflows'];
export function Offer() {
  return <section id="offer" className="scroll-mt-4 border-y-4 border-brandorange bg-carbon py-8 sm:py-10" data-id="element-128" data-mp="ozrytmfibznn">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-129" data-mp="13xkcsa5eofzq">
        <p className="mx-auto w-fit bg-brandorange px-3 py-1 font-display text-[12px] uppercase tracking-[0.2em] text-white sm:text-sm" data-id="element-130" data-mp="13uy6sey5y8jm">
          Special launch offer
        </p>

        <div className="mt-4 border-2 border-line bg-panel2" data-id="element-131" data-mp="2famtd57i95jw">
          <div className="border-b border-line p-4 text-center sm:p-6" data-id="element-132" data-mp="2adwdoizm4bz0">
            <h2 className="font-display text-[22px] uppercase leading-none text-white sm:text-[32px]" data-id="element-133" data-mp="pk7eriduof7v">
              🏍️ Motorcycle Diagnostic Pro™
            </h2>
            <p className="mx-auto mt-2 max-w-[640px] text-[13px] font-semibold uppercase leading-tight tracking-wide text-metal sm:text-[16px]" data-id="element-134" data-mp="uhh1urdroesj">
              The complete visual troubleshooting system for motorcycle technicians
            </p>
          </div>

          <div className="grid gap-5 p-4 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-135" data-mp="6uioi2ky1myu">
            <MockupImage data-id="element-136" data-mp="bsao7irtyddl" />

            <div data-id="element-137" data-mp="btlvvtoec59z">
              <p className="font-display text-[15px] uppercase tracking-wide text-mod-yellow sm:text-[19px]" data-id="element-138" data-mp="bt2b857d32s9">
                Complete 6-in-1 System
              </p>
              <ul className="mt-2 grid gap-1.5" data-id="element-139" data-mp="km5voxgfcfwe">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-140" data-mp="3k7kp4njzhcjs">
                    <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-mod-green" strokeWidth={3.5} data-id="element-141" data-mp="3o9z8d8rkeebl" />
                    <span className="text-[14px] font-semibold leading-snug text-white sm:text-[16px]" data-id="element-142" data-mp="vdnwwp85g39r">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-4 border-2 border-brandorange bg-brandorange/10 px-3 py-3 text-center" data-id="element-143" data-mp="106h1nd3mbblu">
                <p className="font-display text-[17px] uppercase leading-tight text-white sm:text-[22px]" data-id="element-144" data-mp="cgv5kyijlci2">
                  🔥 Get Motorcycle Diagnostic Pro™ today —{' '}
                  <span className="text-brandorange" data-id="element-145" data-mp="7jwbgfyvp5jv">$26.90</span>
                </p>
              </div>

              <div className="mt-4 flex flex-col items-center" data-id="element-146" data-mp="lfgioe58vzbg">
                <CTAButton href={CHECKOUT_URL} external data-id="element-147" data-mp="hf6dv4t6vey6">
                  ⚡ Get instant access
                </CTAButton>
                <p className="mt-3 text-center font-display text-[11.5px] uppercase tracking-wide text-metal sm:text-[13px]" data-id="element-148" data-mp="1wuwv3k9um548">
                  Immediate Digital Access{' '}
                  <span className="mx-1 text-line" data-id="element-149" data-mp="20dukm2xtg7iv">|</span> 🛡️ 7-Day Money-Back
                  Guarantee
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}